module.exports = __webpack_public_path__ + "static/media/skill1_pos_en.211758f7.txt";